import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import routeConstants from '../utils/routeConstants';
import SimpleFormWrapper from '../components/SimpleFormWrapper';
import { login } from '../actions/userActions';
import i18n from '../utils/i18n';
import './styles/LoginContainer.scss';

class LoginContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        email: '',
        password: ''
      },
      errors: {
        email: '',
        password: ''
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.routeToSignUp = this.routeToSignUp.bind(this);
    this.routeToForgotPassword = this.routeToForgotPassword.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value
      },
      errors: {
        ...errors,
        [name]: false
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { user } = this.state;
    if (user.email && user.password) {
      this.props.login(user.email, user.password);
    } else {
      const errors = Object.assign({}, this.state.errors);

      if (!user.email) {
        errors.email = i18n.t('registerLoginScreens.EMAIL_REQUIRED');
      }
      if (!user.password) {
        errors.password = i18n.t('registerLoginScreens.PASSWORD_REQUIRED');
      }

      this.setState({
        errors
      });
    }
  }

  routeToSignUp() {
    this.props.dispatch(push(routeConstants.SIGNUP_ROUTE));
  }

  routeToForgotPassword() {
    this.props.dispatch(push(routeConstants.FORGOT_PASSWORD_ROUTE));
  }

  render() {
    const { user } = this.state;
    const leftButtonContent = (
      <div>
        {i18n.t('registerLoginScreens.NOT_A_MEMBER')}
        {' '}
        <b>
          {i18n.t('registerLoginScreens.JOIN_DEUCE')}
        </b>
      </div>
    );
    return (
      <div className="login-wrapper">
        <SimpleFormWrapper
          onButtonClick={ this.handleSubmit }
          title={ i18n.t('registerLoginScreens.SIGN_IN') }
          subtitle={ i18n.t('registerLoginScreens.SIGN_IN_SUBTITLE') }
          description={ i18n.t('registerLoginScreens.SIGN_IN_DESCRIPTION') }
          buttonTitle={ i18n.t('registerLoginScreens.SIGN_IN') }
          backendError={ this.props.backendError }
          onLeftButtonClick={ this.routeToSignUp }
          leftButtonContent={ leftButtonContent }
          showForgotPasswordLink={ true }
          goToForgotPasswordPage={ this.routeToForgotPassword }
        >
          <div className="form-group">
            <div className="input-label">
              {i18n.t('registerLoginScreens.EMAIL')}
            </div>
            <input
              name="email"
              className={ `private-data form-control${
                this.state.errors.email ? ' is-invalid' : ''
              }` }
              placeholder={ i18n.t(
                'registerLoginScreens.SIGN_IN_EMAIL_PLACEHOLDER'
              ) }
              value={ user.email }
              onChange={ this.handleChange }
            />
            {this.state.errors.email && (
              <div className="error">{this.state.errors.email}</div>
            )}
            <div className="input-label password-label">
              {i18n.t('registerLoginScreens.PASSWORD')}
            </div>
            <input
              name="password"
              type="password"
              className={ `private-data form-control${
                this.state.errors.password ? ' is-invalid' : ''
              }` }
              placeholder={ i18n.t(
                'registerLoginScreens.SIGN_IN_PASSWORD_PLACEHOLDER'
              ) }
              value={ user.password }
              onChange={ this.handleChange }
            />
            {this.state.errors.password && (
              <div className="error">{this.state.errors.password}</div>
            )}
          </div>
        </SimpleFormWrapper>
      </div>
    );
  }
}

LoginContainer.propTypes = {
  login: PropTypes.func.isRequired,
  backendError: PropTypes.string,
  dispatch: PropTypes.func.isRequired
};

LoginContainer.defaultProps = {
  backendError: ''
};

const mapStateToProps = state => ({
  backendError: state.auth.error
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  login: (username, password) => dispatch(login(username, password))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js